// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo-module__logo--3nkO8","logoNotLogged":"header_logo-module__logoNotLogged--3c1Bk"};